import React, { useState } from "react";
import axiosInstance from '../../../../axiosInstance';
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../../config";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";

function SectionCandicateBasicInfo() {
    const navigate = useNavigate();
    const [cv_path, setCvFile] = useState(null);
    const { t } = useTranslation();

    const [user, setUser] = useState({
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        password: "",
        qualification: "",
        city: "",
        state: "",
        country: "",
        designation: "",
        experience: "",
        description: ""
    });

    // Handle input change
    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    }
    const handleFileChange = (e) => {
        setCvFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const {
            firstName,
            lastName,
            mobile,
            email,
            password,
            qualification,
            city,
            state,
            country,
            designation,
            experience,
            description
        } = user;

        const formData = new FormData();
        formData.append("first_name", firstName);
        formData.append("last_name", lastName);
        formData.append("mobile", mobile);
        formData.append("email", email);
        formData.append("password", password);
        formData.append("qualification", qualification);
        formData.append("city", city);
        formData.append("state", state);
        formData.append("country", country);
        formData.append("designation", designation);
        formData.append("experience", experience);
        formData.append("description", description);
        formData.append("cv", cv_path);

        try {
            await axiosInstance.post(`${API_URL}/admin/addCandidate`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            toast.success("Candidate added successfully!");
            navigate("/employer/candidates-list");

            // Reset all fields after success
            setUser({
                firstName: "",
                lastName: "",
                mobile: "",
                email: "",
                password: "",
                qualification: "",
                city: "",
                state: "",
                country: "",
                designation: "",
                experience: "",
                description: ""
            });
            setCvFile(null);

        } catch (error) {
            console.error("Error adding candidate:", error);
            const errorMsg = error.response?.data?.message || "Failed to add candidate";
            toast.error(errorMsg);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0">{t("Basic Informations")}</h4>
                </div>
                <div className="panel-body wt-panel-body p-a20 m-b30 ">
                    <div className="row">
                        {/* First Name */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group">
                                <label>{t("First Name")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="firstName" type="text" placeholder={`${t("Enter First Name")}`} value={user.firstName} onChange={handleChange} />
                                    <i className="fs-input-icon fa fa-user " />
                                </div>
                            </div>
                        </div>

                        {/* Last Name */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group">
                                <label>{t("Last Name")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="lastName" type="text" placeholder={`${t("Enter Last Name")}`} value={user.lastName} onChange={handleChange} />
                                    <i className="fs-input-icon fa fa-user " />
                                </div>
                            </div>
                        </div>

                        {/* Email */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group">
                                <label>{t("Email Address")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="email" type="email" placeholder={`${t("Enter Your Email")}`} value={user.email} onChange={handleChange} />
                                    <i className="fs-input-icon fas fa-at" />
                                </div>
                            </div>
                        </div>

                        {/* Password */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group">
                                <label>{t("Password")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="password" type="password" placeholder={`${t("Enter Your password")}`} value={user.password} onChange={handleChange} />
                                    <i className="fs-input-icon fas fa-at" />
                                </div>
                            </div>
                        </div>

                        {/* Phone */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group">
                                <label>{t("Phone")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="mobile" type="text" placeholder="(251) 1234-456-7890" value={user.mobile} onChange={handleChange} />
                                    <i className="fs-input-icon fa fa-phone-alt" />
                                </div>
                            </div>
                        </div>

                        {/* Qualification */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group">
                                <label>{t("Qualification")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="qualification" type="text" placeholder={`${t("Enter Your Qualification")}`} value={user.qualification} onChange={handleChange} />
                                    <i className="fs-input-icon fa fa-user-graduate" />
                                </div>
                            </div>
                        </div>

                        {/* City */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group">
                                <label>{t("City")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="city" type="text" placeholder={`${t("Enter your city")}`} value={user.city} onChange={handleChange} />
                                    <i className="fs-input-icon fa fa-globe-americas" />
                                </div>
                            </div>
                        </div>

                        {/* State */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group">
                                <label>{t("State")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="state" type="text" placeholder={`${t("Enter your state")}`} value={user.state} onChange={handleChange} />
                                    <i className="fs-input-icon fa fa-globe-americas" />
                                </div>
                            </div>
                        </div>

                        {/* Country */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group city-outer-bx has-feedback">
                                <label>{t("Country")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="country" type="text" placeholder={`${t("Enter your country")}`} value={user.country} onChange={handleChange} />
                                    <i className="fs-input-icon fas fa-map-marker-alt" />
                                </div>
                            </div>
                        </div>

                        {/* Designation */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group city-outer-bx has-feedback">
                                <label>{t("Designation")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="designation" type="text" placeholder={`${t("Enter Your Designation")}`} value={user.designation} onChange={handleChange} />
                                    <i className="fs-input-icon fa fa-user-tie" />
                                </div>
                            </div>
                        </div>

                        {/* Experience */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="form-group city-outer-bx has-feedback">
                                <label>{t("Years of experience")}</label>
                                <div className="ls-inputicon-box">
                                    <input className="form-control" name="experience" type="text" placeholder={`${t("Enter Your Experience")}`} value={user.experience} onChange={handleChange} />
                                    <i className="fs-input-icon  fa fa-briefcase" />
                                </div>
                            </div>
                        </div>

                        {/* Description */}
                        <div className="col-md-12">
                            <div className="form-group city-outer-bx has-feedback">
                                <label>{t("Description")}</label>
                                <div className="ls-inputicon-box">
                                    <textarea className="form-control" name="description" rows={3} placeholder={`${t("Tell something about yourself")}...`} value={user.description} onChange={handleChange} />
                                    <i className="fs-input-icon fa fa-align-left" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12">
                            <div className="cv-upload-section mt-5">
                                <label className="font-semibold text-lg">{t("Upload your CV")}</label>
                                <div className="mt-2 mb-3 text-gray-400 text-sm">
                                    {cv_path ? (
                                        <a href={cv_path.url} target="_blank" rel="noopener noreferrer" className="text-green-600">
                                            {cv_path.name}
                                        </a>
                                    ) : (
                                        <span className="uppercase">{t("No CVs Uploaded Yet")}</span>
                                    )}

                                </div>
                                <div
                                    className="d-flex flex-column align-items-center justify-content-center mb-5"
                                    style={{ height: "100px", width: '100%', border: '2px dashed black', borderRadius: '6px', cursor: 'pointer' }}
                                    onClick={() => document.getElementById("fileUpload").click()}
                                >
                                    <h3>{t("Upload Your CV")}</h3>
                                    <input
                                        type="file"
                                        id="fileUpload"
                                        accept="application/pdf"
                                        onChange={handleFileChange}
                                        className="d-none"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Submit */}
                        <div className="col-lg-12 col-md-12">
                            <div className="text-left">
                                <button type="submit" className="site-button">{t("Save Changes")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default SectionCandicateBasicInfo;